"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarControls = void 0;
const types_1 = require("../types");
const Button_1 = require("./Button/Button");
const FillSpace_1 = require("./FillSpace/FillSpace");
const Separator_1 = require("./Separator/Separator");
const SplitButton_1 = require("./SplitButton/SplitButton");
const Text_1 = require("./Text/Text");
exports.ToolbarControls = {
    [types_1.TOOLBAR_ITEM_TYPE.button]: Button_1.Button,
    [types_1.TOOLBAR_ITEM_TYPE.fillSpace]: FillSpace_1.FillSpace,
    [types_1.TOOLBAR_ITEM_TYPE.separator]: Separator_1.Separator,
    [types_1.TOOLBAR_ITEM_TYPE.text]: Text_1.Text,
    [types_1.TOOLBAR_ITEM_TYPE.group]: SplitButton_1.SplitButton
};
//# sourceMappingURL=ToolbarControls.js.map